export class DcIdReq {
    dcId: number
    constructor(dcId:number){
        this.dcId = dcId
    }
} 